import { Action } from 'redux';

import { SetTags } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface SetTagsAction extends Action {
  content: IContentInfo[];
}

export function setTags(...content: IContentInfo[]): SetTagsAction {
  return {
    type: SetTags,
    content: content
  };
}

export const isSetTagsAction = isActionFactory<SetTagsAction>(SetTags);
